module.exports = __webpack_public_path__ + "a0b6ae1ff39868054d278c05afe19099.MP3";